import React from 'react';
import { Helmet } from 'react-helmet';
import '../Compute.css';

const ComputeHe = () => {
    return (
        <div dir="rtl">
            <Helmet>
                {/* Primary Meta Tags */}
                <title>שרתי ענן VPS - שרתים וירטואליים בביצועים גבוהים | Epicfinal</title>
                <meta name="title" content="שרתי ענן VPS - שרתים וירטואליים בביצועים גבוהים | Epicfinal" />
                <meta name="description" content="אחסון VPS גמיש החל מ-₪219.90
 לחודש. NVMe SSD, עד 35GB RAM, 16 vCPUs, גישת root מלאה, הגנת DDoS ו-99.9% זמינות. מושלם ל-SaaS, מסחר אלקטרוני וסביבות ייצור." />
                <meta name="keywords" content="אחסון VPS, ענן VPS, שרת וירטואלי פרטי, מחשוב ענן, NVMe VPS, SSD VPS, VPS מנוהל, VPS גמיש, שרת VPS, שרת ענן, משאבים ייעודיים, Linux VPS, גישת root, אחסון ייצור" />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <meta name="author" content="Epicfinal" />
                <link rel="canonical" href="https://epicfinal.com/he/compute" />

                {/* Language & Locale */}
                <html lang="he" />
                <meta property="og:locale" content="he_IL" />
                <link rel="alternate" href="https://epicfinal.com/compute" hrefLang="en" />
                <link rel="alternate" href="https://epicfinal.com/he/compute" hrefLang="he" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/compute" />
                <meta property="og:title" content="שרתי ענן VPS - שרתים וירטואליים בביצועים גבוהים | Epicfinal" />
                <meta property="og:description" content="אחסון VPS גמיש החל מ-₪219.90
 לחודש. SSD NVMe, משאבים ייעודיים, גישת root מלאה וזמינות של 99.9%." />
                <meta property="og:image" content="https://epicfinal.com/android-chrome-512x512.png" />
                <meta property="og:image:alt" content="Epicfinal Cloud VPS - שרתים וירטואליים בביצועים גבוהים" />
                <meta property="og:site_name" content="Epicfinal" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://epicfinal.com/he/compute" />
                <meta name="twitter:title" content="שרתי ענן VPS - שרתים וירטואליים גמישים | Epicfinal" />
                <meta name="twitter:description" content="VPS גמיש החל מ-₪219.90
 לחודש. SSD NVMe, עד 35GB RAM, הגנת DDoS ו-99.9% זמינות." />
                <meta name="twitter:image" content="https://epicfinal.com/android-chrome-512x512.png" />

                {/* Schema.org Structured Data */}
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "WebPage",
                        "name": "שרתי ענן VPS - שרתים וירטואליים בביצועים גבוהים",
                        "description": "אחסון VPS גמיש עם אחסון SSD NVMe, משאבים ייעודיים, גישת root מלאה וערבות לזמינות של 99.9%.",
                        "url": "https://epicfinal.com/he/compute",
                        "provider": {
                            "@type": "Organization",
                            "name": "Epicfinal",
                            "url": "https://epicfinal.com"
                        },
                        "breadcrumb": {
                            "@type": "BreadcrumbList",
                            "itemListElement": [
                                {"@type": "ListItem", "position": 1, "name": "בית", "item": "https://epicfinal.com/he"},
                                {"@type": "ListItem", "position": 2, "name": "Compute VPS", "item": "https://epicfinal.com/he/compute"}
                            ]
                        }
                    }
                `}</script>
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "Product",
                        "name": "שרתי ענן Epicfinal VPS",
                        "description": "שרתים וירטואליים בביצועים גבוהים עם אחסון NVMe SSD, מעבדים ייעודיים וגישת root מלאה",
                        "brand": {"@type": "Brand", "name": "Epicfinal"},
                        "category": "Cloud Computing",
                        "offers": [
                            {"@type": "Offer", "name": "VPS-A Core", "price": "226.90", "priceCurrency": "ILS", "priceValidUntil": "2025-12-31", "availability": "https://schema.org/InStock", "url": "https://my.epicfinal.com/index.php?rp=/store/compute/vps1&language=hebrew&currency=2"},
                            {"@type": "Offer", "name": "VPS-B Edge", "price": "591.10", "priceCurrency": "ILS", "priceValidUntil": "2025-12-31", "availability": "https://schema.org/InStock", "url": "https://my.epicfinal.com/index.php?rp=/store/compute/vm-edge&language=hebrew&currency=2"},
                            {"@type": "Offer", "name": "VPS-C MTI-L", "price": "948.10", "priceCurrency": "ILS", "priceValidUntil": "2025-12-31", "availability": "https://schema.org/InStock", "url": "https://my.epicfinal.com/index.php?rp=/store/compute/mti-l&language=hebrew&currency=2"}
                        ],
                        "aggregateRating": {"@type": "AggregateRating", "ratingValue": "4.8", "reviewCount": "95", "bestRating": "5", "worstRating": "1"}
                    }
                `}</script>
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": [
                            {"@type": "Question", "name": "מהו אחסון VPS?", "acceptedAnswer": {"@type": "Answer", "text": "אחסון VPS (Virtual Private Server) מספק משאבים ייעודיים על שרת וירטואלי. בניגוד לאחסון שיתופי, אתם מקבלים מעבד, זיכרון ואחסון מובטחים עם גישת root מלאה לשליטה מוחלטת."}},
                            {"@type": "Question", "name": "אילו תוכניות VPS מציעה Epicfinal?", "acceptedAnswer": {"@type": "Answer", "text": "אנו מציעים שלוש רמות VPS: Core (4 vCPU, 8GB RAM, ₪219.90/חודש), Edge (8 vCPU, 16GB RAM, ₪589.90
/חודש), ו-MTI-L (16 vCPU, 35GB RAM, ₪949.00
/חודש). כולן כוללות אחסון NVMe SSD ותעבורה של 20TB."}},
                            {"@type": "Question", "name": "האם ניתן להוסיף שירותים מנוהלים ל-VPS שלי?", "acceptedAnswer": {"@type": "Answer", "text": "כן, ניהול מלא זמין כתוספת הכוללת ניטור 24/7, עדכוני אבטחה, גיבויים מרוחקים ותמיכה טכנית בעדיפות."}}
                        ]
                    }
                `}</script>
            </Helmet>

            <div className="compute-page">
                {/* Hero Section */}
                <section className="compute-hero">
                    <div className="container">
                        <div className="compute-hero-content">
                            <h1 className="compute-hero-title compute-hero-title-he">
                                שרתי ענן VPS (Compute)
                            </h1>
                            <p className="compute-hero-subtitle">
                                שרתים וירטואליים עוצמתיים לפרויקטים שלכם
                            </p>
                            <p className="compute-hero-description">
                                קבלו משאבים ייעודיים עם פתרונות ה-VPS בביצועים גבוהים שלנו. מושלם לאפליקציות SaaS, חנויות מקוונות וסביבות ייצור.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Pricing Plans Section */}
                <section className="compute-pricing">
                    <div className="container">
                        <div className="compute-section-header">
                            <h2>בחרו תוכנית Compute</h2>
                            <p>פתרונות VPS גמישים לכל עומס עבודה</p>
                        </div>
                        <div className="compute-pricing-grid">
                            {/* Core Plan */}
                            <div className="compute-pricing-card" id="core">
                                <div className="compute-pricing-header">
                                    <div className="compute-plan-badge core">Core</div>
                                    <h3>VPS-A Core Compute</h3>
                                    <p className="compute-pricing-tagline">אידיאלי למספר אתרים, פרויקטי SaaS קטנים, או סביבות בדיקה + ייצור על אותו VPS</p>
                                </div>
                                <div className="compute-pricing-price">
                                    <span className="compute-price-label">החל מ-</span>
                                    <span className="compute-price-amount">₪219.90
                                    </span>
                                    <span className="compute-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="compute-pricing-features">
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>4 shared vCPUs</strong>
                                            <span className="compute-feature-label">מעבד (CPU)</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>8 GB RAM</strong>
                                            <span className="compute-feature-label">זיכרון</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>80 GB NVMe SSD</strong>
                                            <span className="compute-feature-label">אחסון</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>20 TB / חודש</strong>
                                            <span className="compute-feature-label">תעבורה</span>
                                        </div>
                                    </li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/compute/vps1&language=hebrew&currency=2"
                                    className="compute-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    הזמינו עכשיו
                                </a>
                            </div>

                            {/* Edge Plan */}
                            <div className="compute-pricing-card featured" id="edge">
                                <div className="compute-pricing-badge-top">הבחירה הפופולרית</div>
                                <div className="compute-pricing-header">
                                    <div className="compute-plan-badge edge">Edge</div>
                                    <h3>VPS-B Edge Compute</h3>
                                    <p className="compute-pricing-tagline">בנוי לחנויות מקוונות צומחות, עומסי SaaS כבדים יותר, או מספר קונטיינרים ושירותים הרצים במקביל</p>
                                </div>
                                <div className="compute-pricing-price">
                                    <span className="compute-price-label">החל מ-</span>
                                    <span className="compute-price-amount">₪589.90
                                    </span>
                                    <span className="compute-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="compute-pricing-features">
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>8 shared vCPUs</strong>
                                            <span className="compute-feature-label">מעבד (CPU)</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>16 GB RAM</strong>
                                            <span className="compute-feature-label">זיכרון</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>160 GB SSD</strong>
                                            <span className="compute-feature-label">אחסון</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>20 TB / חודש</strong>
                                            <span className="compute-feature-label">תעבורה</span>
                                        </div>
                                    </li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/compute/vm-edge&language=hebrew&currency=2"
                                    className="compute-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    הזמינו עכשיו
                                </a>
                            </div>

                            {/* MTI-L Plan */}
                            <div className="compute-pricing-card" id="mti-l">
                                <div className="compute-pricing-header">
                                    <div className="compute-plan-badge mti">MTI-L</div>
                                    <h3>VPS-C MTI-L Compute</h3>
                                    <p className="compute-pricing-tagline">מיועד לעומסי ייצור כבדים, פרויקטים מרובים של לקוחות, או אפליקציות רעבות למשאבים שזקוקות להרבה RAM ומעבד</p>
                                </div>
                                <div className="compute-pricing-price">
                                    <span className="compute-price-label">החל מ-</span>
                                    <span className="compute-price-amount">₪949.00
                                    </span>
                                    <span className="compute-price-period">₪ / חודשי</span>
                                </div>
                                <ul className="compute-pricing-features">
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>16 shared vCPUs</strong>
                                            <span className="compute-feature-label">מעבד (CPU)</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>35 GB RAM</strong>
                                            <span className="compute-feature-label">זיכרון</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>320 GB SSD</strong>
                                            <span className="compute-feature-label">אחסון</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="compute-feature-item">
                                            <strong>20 TB / חודש</strong>
                                            <span className="compute-feature-label">תעבורה</span>
                                        </div>
                                    </li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/compute/mti-l&language=hebrew&currency=2"
                                    className="compute-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    הזמינו עכשיו
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Managed Services Add-on */}
                <section className="compute-managed">
                    <div className="container">
                        <div className="compute-managed-content">
                            <div className="compute-managed-icon">
                                <i className="las la-shield-alt"></i>
                            </div>
                            <div className="compute-managed-text">
                                <h2>ניהול מלא זמין</h2>
                                <p>הוסיפו ניהול מלא ל-VPS שלכם לשקט נפשי נוסף</p>
                            </div>
                        </div>
                        <div className="compute-managed-features">
                            <div className="compute-managed-feature">
                                <i className="las la-chart-area"></i>
                                <h4>ניטור</h4>
                                <p>ניטור שרתים רציף והתראות פרואקטיביות</p>
                            </div>
                            <div className="compute-managed-feature">
                                <i className="las la-lock"></i>
                                <h4>ניהול אבטחה</h4>
                                <p>עדכוני אבטחה שוטפים ותיקון פגיעויות</p>
                            </div>
                            <div className="compute-managed-feature">
                                <i className="las la-database"></i>
                                <h4>גיבויים מרוחקים</h4>
                                <p>שמירת גיבויים ל-7 ימים עם שחזור קל</p>
                            </div>
                            <div className="compute-managed-feature">
                                <i className="las la-headset"></i>
                                <h4>תמיכה טכנית</h4>
                                <p>תמיכה בעדיפות מצוות המומחים שלנו</p>
                            </div>
                        </div>
                        <div className="compute-managed-cta">
                            <p className="compute-managed-note">זמין כתוספת לכל תוכנית VPS</p>
                        </div>
                    </div>
                </section>

                {/* Features Section */}
                <section className="compute-features">
                    <div className="container">
                        <div className="compute-section-header">
                            <h2>למה לבחור ב-VPS שלנו</h2>
                            <p>תשתית ברמה ארגונית לאפליקציות שלכם</p>
                        </div>
                        <div className="compute-features-grid">
                            <div className="compute-feature-card">
                                <i className="las la-server"></i>
                                <h3>אחסון NVMe SSD</h3>
                                <p>כונני NVMe מהירים במיוחד לביצועים מקסימליים</p>
                            </div>
                            <div className="compute-feature-card">
                                <i className="las la-network-wired"></i>
                                <h3>פס רחב גבוה</h3>
                                <p>מכסות תעבורה נדיבות עם רשת במהירות גבוהה</p>
                            </div>
                            <div className="compute-feature-card">
                                <i className="las la-expand-arrows-alt"></i>
                                <h3>גישת Root מלאה</h3>
                                <p>שליטה מלאה על סביבת השרת שלכם</p>
                            </div>
                            <div className="compute-feature-card">
                                <i className="las la-shield-alt"></i>
                                <h3>הגנת DDoS</h3>
                                <p>הגנה מובנית מפני התקפות מבוזרות</p>
                            </div>
                            <div className="compute-feature-card">
                                <i className="las la-clock"></i>
                                <h3>99.9% זמינות</h3>
                                <p>תשתית אמינה עם זמן פעילות מובטח</p>
                            </div>
                            <div className="compute-feature-card">
                                <i className="las la-cog"></i>
                                <h3>ניהול קל</h3>
                                <p>פאנל ניהול אינטואיטיבי לניהול השרת</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="compute-cta">
                    <div className="container">
                        <div className="compute-cta-content">
                            <h2>מוכנים להפעיל את ה-VPS שלכם?</h2>
                            <p>התחילו עם משאבי מחשוב ענן עוצמתיים היום</p>
                            <div className="compute-cta-buttons">
                                <a href="#core" className="compute-btn compute-btn-light">
                                    צפו בתוכניות
                                </a>
                                <a href="/contact1" className="compute-btn compute-btn-outline">
                                    צרו קשר עם המכירות
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ComputeHe;
